import Drawer from 'components/Drawer';
import EditProfileForm from 'forms/EditProfileForm';
import { useDispatch } from 'react-redux';
import fetchApi from 'hooks/fetchApi';
import API_NAME from 'services/api';
import { getUserDetailsStart } from 'store/user/actions';
import { getCorrectImageBase64Format } from 'utils/getCorrectImageBase64Format';

import { IEditProfileDrawer } from './Types';

const EditProfileDrawer = ({
  onClose,
  onUdate,
  open,
  initialValues,
}: IEditProfileDrawer) => {
  const dispatch = useDispatch();
  const { action } = fetchApi();

  const onEditProfile = async (value) => {
    try {
      // eslint-disable-next-line no-param-reassign
      value.profilePhoto =
        value?.profilePhoto 
          ? value?.profilePhoto
          : '';
      // eslint-disable-next-line no-param-reassign
      value.coverPhoto =
        value?.coverPhoto 
          ? value?.coverPhoto
          : '';
      // NEED TO CHECK TYPE ARRAY
      const updateValue = {
        isBusiness: value?.isBusiness,
        fullName: value?.fullName,
        interests: value?.interests,
        brands: value?.brands,
        description: value?.description,
        collaborators: value?.collaborators,
        website: value?.website,
        username: value?.username,
        ...(value?.profilePhoto && {
          profilePhoto: getCorrectImageBase64Format(value?.profilePhoto),
        }),
        ...(value?.coverPhoto && {
          coverPhoto: getCorrectImageBase64Format(value?.coverPhoto),
        }),
        business: {
          isActive: value?.isBusiness,
          interests: [],
          ...(value?.email && {
            email: value?.email,
          }),
          ...(value?.phone && {
            phone: value?.phone,
          }),
        },
        ...(value?.location && {
          location: {
            lat: value?.location?.lat,
            lng: value?.location?.lng,
            address: value?.location?.address,
            name: value?.location?.name,
          },
        }),
      };
      
      const res = await action(API_NAME.USER_UPDATE, {
        params: {
          id: initialValues?._id,
        },
        body: updateValue,
      });

      if (res?.result === 'error') return;
      await dispatch(getUserDetailsStart(initialValues?._id));
      onUdate({
        ...initialValues,
        ...updateValue,
        ...(value?.profilePhoto && {
          profilePhoto: value?.profilePhoto,
        }),
        ...(value?.coverPhoto && {
          coverPhoto: value?.coverPhoto,
        }),
      });
      onClose();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Drawer open={open} onDrawerClose={onClose} loading rootForm>
      <EditProfileForm
        onSubmit={onEditProfile}
        onIconClick={onClose}
        // inProgress={loading[API_NAME.USER_UPDATE]}
        initialValues={{
          profilePhoto: initialValues?.profilePhoto,
          coverPhoto: initialValues?.coverPhoto,
          isBusiness: initialValues?.isBusiness,
          fullName: initialValues?.fullName,
          interests: initialValues?.interests,
          brands: initialValues?.brands,
          description: initialValues?.description,
          collaborators: initialValues?.collaborators,
          website: initialValues?.website,
          username: initialValues?.username,

          ...(initialValues?.business?.email && {
            email: initialValues?.business?.email,
          }),
          ...(initialValues?.business?.phone && {
            phone: initialValues?.business?.phone,
          }),
          ...(initialValues?.geoLocation?.coordinates && {
            location: {
              lat: initialValues?.geoLocation?.coordinates[1],
              lng: initialValues?.geoLocation?.coordinates[0],
              address: initialValues?.location?.address,
            },
          }),
        }}
      />
    </Drawer>
  );
};

export default EditProfileDrawer;
